import React, { useState } from 'react';
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from 'reactstrap';
import { Parallax } from 'react-scroll-parallax';
import SEO from '../components/seo';
import categoryImg from '../images/contact-us.png';
import circle from '../images/circle.svg';
import purpleBubble from '../images/purple-circle.svg';
import greenBubble from '../images/green-bubble.svg';
import '../styles/contact.scss';

const ContactPage = () => {
  const [notification, setNotification] = useState(false);
  const handleSubmit = (event) => {
    event.preventDefault();
    setNotification(!notification);
  };
  return (
    <>
      <SEO
        title="Contact"
        description="Chat with our sales team about how Charli can support your business."
        image={categoryImg}
      />
      <Container fluid className="section-banner">
        <Row>
          <Col md="6" sm="12">
            <h1 className="page-header">Start a conversation</h1>
          </Col>
          <Col md="6" sm="12">
            <div className="category-thumbnail">
              <img src={categoryImg} alt="blog-category" />
            </div>
            <Parallax className="circle wow" y={[20, -100]} tagOuter="figure">
              <img src={circle} data-wow-delay="0.5s" alt="charli-ai" />
            </Parallax>
            <Parallax
              className="purple-dot wow"
              y={[20, -200]}
              tagOuter="figure"
            >
              <img src={purpleBubble} alt="charli-ai" />
            </Parallax>
          </Col>
        </Row>
      </Container>
      <Container fluid className="section-contact-form">
        <Parallax className="green-bubble wow" y={[20, -100]} tagOuter="figure">
          <img src={greenBubble} data-wow-delay="0.5s" alt="charli-ai" />
        </Parallax>
        <Container>
          <Row>
            <Col md="12" lg="6" className="contact-form-container">
              <h2>
                Chat with our sales team about how Charli can support your
                business.
              </h2>
              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <Input name="firstname" placeholder="First Name" />
                </FormGroup>
                <FormGroup>
                  <Input name="lastname" placeholder="Last Name" />
                </FormGroup>
                <FormGroup>
                  <Input name="email" placeholder="Email" required />
                  <FormFeedback>
                    Oh noes! that name is already taken
                  </FormFeedback>
                </FormGroup>
                <FormGroup>
                  <Input name="phone" placeholder="Phone" />
                </FormGroup>
                <FormGroup>
                  <Input name="company" placeholder="Company Name" required />
                </FormGroup>

                <FormGroup>
                  <Label for="challenge">
                    What productivity challenge are you trying to solve:
                  </Label>
                  <Input type="select" id="challenge">
                    <option>I need to fix my content management process</option>
                    <option>
                      I need proactive reminders for important tasks
                    </option>
                    <option>
                      I need a way to easily find and share content
                    </option>
                    <option>I want to tame my inbox</option>
                    <option>All of the above</option>
                    <option>Other</option>
                  </Input>
                </FormGroup>
                <FormGroup>
                  <Label for="otherInfo">Anything else we should know?</Label>
                  <Input
                    type="textarea"
                    bsSize="lg"
                    name="otherInfo"
                    id="otherInfo"
                  />
                </FormGroup>

                <div className="button-orange">
                  <Input
                    type="submit"
                    name="text"
                    id="exampleText"
                    value="Send"
                  />
                </div>
              </Form>
              {notification ? (
                <div className="notification-message">
                  <p>
                    Thank you for contacting us! We will be in touch with you
                    shortly.
                  </p>
                </div>
              ) : (
                ''
              )}
            </Col>
            <Col md="12" lg="6" className="cta-wrapper">
              <h4>What’s Charli all about?</h4>
              <div className="button-teal long">
                <a
                  href="https://charliai.typeform.com/to/IhzcZhjI"
                  target="_blank"
                  rel="noreferrer"
                >
                  Try for Free
                </a>
              </div>
              <h4>Get product support</h4>
              <div className="button-teal long">
                <a
                  href="https://support.charli.ai/hc/en-us"
                  target="_blank"
                  rel="noreferrer"
                >
                  View Knowledge Base
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};

export default ContactPage;
